import React from 'react';
import { Type } from '../../../../../general/modules/filter/dataModel';

import { FileManagerRow, FMColumn } from '../../model';

import './styles.scss';
import { useSelector } from 'react-redux';
import { getFileManager } from '../../selectors/selectors';

export const MisleadLevelCellInner: React.FC<{
  rowData: FileManagerRow;
  column: FMColumn<Type.ID>;
}> = ({ rowData, column }) => {
  const warnings = useSelector(getFileManager).creativeMisleadStatusWarnings;
  const warn = warnings.includes(rowData.id);
  return (
    <span
      title={column.toDisplayString(rowData) ?? undefined}
      className={`conversion-status-error__item mislead-level-warning__${warn}`}
    >
      {column.toDisplayString(rowData) ?? ''}
    </span>
  );
};
